import { json, jsonParseLinter } from '@codemirror/lang-json'
import { linter } from '@codemirror/lint'
import { CodeEditorV2, stringify } from '@portal/components'
import React from 'react'

import { DQLResult } from '../../types'
import NoResults from './NoResults'
import { DQLMutationResult } from './QueryResultTable'

type QueryResultJsonProps = {
  height: number
  width: number
  data: DQLResult[] | DQLMutationResult[]
}

export default function QueryResultJson({
  data,
  height,
  width,
}: QueryResultJsonProps) {
  const jsonLinter = linter(jsonParseLinter())

  if (!data.length)
    return (
      <div
        className="overflow-y-auto bg-background-surface"
        style={{ height, width }}
      >
        <NoResults />
      </div>
    )

  return (
    <div
      className="overflow-y-auto bg-background-surface"
      style={{ height, width }}
    >
      <CodeEditorV2
        height={height.toString()}
        basicSetup={{
          lineNumbers: true,
          highlightActiveLineGutter: false,
        }}
        value={stringify(data, null, 2)}
        language={json()}
        readOnly={true}
        linter={jsonLinter}
        className="h-full w-full"
      />
    </div>
  )
}
